import { call, put, takeLatest } from 'redux-saga/effects';
import { SET_NOTIFICATION } from './cafe/actionTypes'

const safe = (saga, ...args) => function* (action) {
    try {
        yield call(saga, ...args, action)
    } catch (err) {
        console.error(err)
        yield put({ type: SET_NOTIFICATION, notification: { text: 'warning.someWrong', type: 'error' } })
    }
}

export const takeLatestSafe = (pattern, saga, ...args) => takeLatest(pattern, safe(saga, ...args))

